export default {
	name: 'access-management',
	path: '/access-management',
	redirect: '/access-management/visitor-system',
	meta: {
		title: '进出管理',
		icon: 'icon-access-management'
	},
	children: [
		{
			name: 'visitor-system',
			path: 'visitor-system',
			fullPath: '/access-management/visitor-system',
			meta: {
				title: '访客管理系统',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "visitor-system" */ '@/views/access-management/visitor-system')
		},
		{
			name: 'batch-application',
			path: 'batch-application',
			fullPath: '/access-management/visitor-system/batchapplication',
			meta: {
				// title: '批量申请'
			},
			component: () =>
				import(/* webpackChunkName: "import" */ '@/views/access-management/visitor-system/tabs/visitor-list/batchapplication')
		},
		// 宿舍管理系统
		{
			name: 'dorm-management',
			path: 'dorm',
			fullPath: '/access-management/dorm',
			redirect: '/access-management/dorm/record',
			meta: {
				title: '宿舍管理系统'
			},
			component: () =>
				import(/* webpackChunkName: "dorm" */ '@/views/access-management/dorm-management'),
			children: [
				{
					name: 'dorm-record',
					path: 'record',
					fullPath: '/access-management/dorm/record',
					meta: {
						title: '进出记录'
					},
					component: () =>
						import(/* webpackChunkName: "record" */ '@/views/access-management/dorm-management/record')
				},
				{
					name: 'dorm-rules',
					path: 'rules',
					fullPath: '/access-management/dorm/rules',
					meta: {
						title: '规则管理'
					},
					component: () =>
						import(/* webpackChunkName: "rules" */ '@/views/access-management/dorm-management/rules')
				},
				{
					name: 'dorm-ruleSet',
					path: 'ruleSet',
					fullPath: '/access-management/dorm/set',
					meta: {
						title: '管理规则设置'
					},
					component: () =>
						import('@/views/access-management/dorm-management/rules/set')
				},
				{
					name: 'dorm-manage',
					path: 'manage',
					fullPath: '/access-management/dorm/manage',
					meta: {
						title: '宿舍信息管理'
					},
					component: () =>
						import(/* webpackChunkName: "manage" */ '@/views/access-management/dorm-management/manage')
				},
				{
					name: 'dorm-import',
					path: 'boarder-import',
					fullPath: '/access-management/dorm/boarder-import',
					meta: {
						// title: '批量修改住宿生'
					},
					component: () =>
						import(/* webpackChunkName: "import" */ '@/views/access-management/dorm-management/manage/boarder/import')
				},
				{
					name: 'dorm-boarder-edit',
					path: 'boarder-edit/:id',
					fullPath: '/access-management/dorm/boarder-edit',
					meta: {
						title: '住宿生信息修改'
					},
					component: () =>
						import(/* webpackChunkName: "import" */ '@/views/access-management/dorm-management/manage/boarder/edit')
				},
				{
					name: 'dorm-setting',
					path: 'dorm-setting',
					fullPath: '/access-management/dorm/dorm-setting',
					meta: {
						title: '宿舍信息管理'
					},
					component: () =>
						import(/* webpackChunkName: "import" */ '@/views/access-management/dorm-management/manage/dorm-building/setting')
				},
				{
					name: 'dorm-detail',
					path: 'dorm-detail/:id',
					fullPath: '/access-management/dorm/dorm-detail',
					meta: {
						title: '宿舍楼详情'
					},
					component: () =>
						import(/* webpackChunkName: "detail" */ '@/views/access-management/dorm-management/manage/dorm-building/detail')
				},
				{
					name: 'dorm-edit',
					path: 'dorm-edit/:id',
					fullPath: '/access-management/dorm/edit',
					meta: {
						title: '宿舍楼修改'
					},
					component: () =>
						import(/* webpackChunkName: "edit" */ '@/views/access-management/dorm-management/manage/dorm-building/setting')
				},
				{
					name: 'dorm-summary',
					path: 'summary',
					fullPath: '/access-management/dorm/summary',
					meta: {
						title: '数据汇总及明细'
					},
					component: () =>
						import(/* webpackChunkName: "summary" */ '@/views/access-management/dorm-management/summary')
				},
				// 宿舍识别日志
				{
					name: 'dorm-discernLog',
					path: 'discern-log',
					fullPath: '/access-management/dorm/discern-log',
					meta: {
						title: '宿舍识别日志'
					},
					component: () =>
						import(/* webpackChunkName: "discernLog" */ '@/views/access-management/dorm-management/discern-log')
				},
				// 宿舍未归统计
				{
					name: 'dorm-unrecognizedStatistics',
					path: 'unrecognized-statistics',
					fullPath: '/access-management/dorm/unrecognized-statistics',
					meta: {
						title: '宿舍未归统计'
					},
					component: () =>
						import(/* webpackChunkName: "discernLog" */ '@/views/access-management/dorm-management/unrecognized-statistics')
				},
				{
					name: 'dormitory-access-management',
					path: '/access-management/dorm/dormitory-access-management',
					meta: {
						title: '宿舍进出管理'
					},
					component: () =>
						import(/* webpackChunkName: "dormitory-access-management" */ '@/views/access-management/dorm-management/dormitory-access-management')
				}
			]
		},
		// 门禁规则
		{
			name: 'entrance-guard-rules',
			path: 'entrance-guard-rules',
			fullPath: '/access-management/entrance-guard-rules',
			meta: {
				title: '门禁规则'
			},
			component: () =>
				import(/* webpackChunkName: "entrance" */ '@/views/access-management/entrance-guard-rules')
		},
		// 门禁规则编辑
		{
			name: 'entrance-guard-rules-edit',
			path: '/entrance-guard-rules-edit',
			fullPath: '/access-management/entrance-guard-rules-edit',
			meta: {
				title: '门禁规则'
			},
			component: () =>
				import(/* webpackChunkName: "entrance" */ '@/views/access-management/entrance-guard-rules/editting')
		}
	]
};
